<ul class="list-unstyled" *ngIf="menus">
    <li *ngFor="let menu of menus; trackBy: trackByMenuId" class="mb-1">

        <!-- Display the arrow and menu title -->
        <button class="btn btn-toggle" (click)="toggleMenu(menu.index)" type="button">
            <!-- Arrow based on the expansion state -->
            <span [ngClass]="{'bi-plus': !isExpanded(menu.index), 'bi bi-dash': isExpanded(menu.index)}"></span>
            {{ menu.title }}
        </button>

        <!-- Recursively render child menus if the menu is expanded -->
        <ul *ngIf="isExpanded(menu.index)">
            <app-menu [menus]="getNestedMenus(menu.index)" [menusArray]="menusArray">
            </app-menu>
        </ul>
    </li>
</ul>